<template>
  <AutoComplete
    v-model="inputValue"
    :suggestions="suggestions"
    :field="labelField"
    @complete="onSearch($event)"
    @item-select="onSelect($event)"
    @clear="onClear()"
    dropdown
    :scrollHeight="scrollHeight"
  ></AutoComplete>
</template>

<script>
export default {
  name: 'AppAutoComplete',
  props: {
    labelField: {
      type: String,
      default: () => 'name',
    },
    valueField: {
      type: String,
      default: () => 'id',
    },
    options: {
      type: Array,
      default: () => [],
    },
    externalSeach: Boolean,
    modelValue: [Number, String],
    scrollHeight: String,
  },
  data() {
    return {
      query: '',
      inputValue: '',
    };
  },
  created() {
    this.loadInputValue();
  },
  watch: {
    modelValue() {
      this.loadInputValue();
    },
  },
  computed: {
    suggestions() {
      if (this.externalSeach) {
        return [...this.options];
      }
      return this.options.filter((option) => {
        return (
          !this.query ||
          option[this.labelField]
            .toLowerCase()
            .includes(this.query.toLowerCase())
        );
      });
    },
  },
  methods: {
    onSearch({ query }) {
      this.query = null;

      if (query) {
        this.$emit('update:modelValue', null);
      }

      this.$emit('search', { query });
      this.query = query;
    },
    onSelect({ value }) {
      this.$emit('update:modelValue', value[this.valueField]);
    },
    loadInputValue() {
      if (this.modelValue) {
        this.inputValue = this.options.find((option) => {
          return option[this.valueField] === this.modelValue;
        });
      } else {
        this.inputValue = '';
      }
    },
    onClear() {
      this.$emit('update:modelValue', null);
    },
  },
};
</script>

<style>
</style>